module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Donald Grey Barnhouse\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('BR'), _c('B', [_vm._v("DONALD GREY BARNHOUSE")]), _vm._v(" (1895–1960) was a renowned evangelical preacher and pastor of Tenth Presbyterian Church in Philadelphia. Most famous for his radio broadcasts and public speaking, Barnhouse also founded, wrote for, and edited "), _c('I', [_vm._v("Revelation")]), _vm._v(" and "), _c('I', [_vm._v("Eternity")]), _vm._v(" magazines.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1LCPe7/tc-custom/9781467467391.jpg?1728851812654",
      "alt": "This image is the cover for the book Romans, vol 7: God's Heirs"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Romans, vol 7: God's Heirs\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("Romans ")]), _vm._v("is based on Donald Barnhouse’s renowned series of radio broadcasts on the epistle from 1949 until his death in 1960. Demonstrating the author’s acute understanding of Romans and heart for effective preaching, these classic studies reverently expound even the most difficult passage in a clear way. Examining the Letter to the Romans phrase by phrase, Barnhouse elucidates the Scripture with reference to both its immediate context and the Bible’s overarching truths. Barnhouse’s zeal for a universal appreciation of the epistle fuels his commentary and invites all readers into a deeper understanding of the life-changing message of Romans.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0